import moment from 'moment/moment';
export const useTicks = (customRanges)=>{
    const startDate = moment().utc();
    const endDate = moment().utc();
    const ticksPoints = [];
    startDate.startOf('day');
    endDate.endOf('day');
    ticksPoints.push(+startDate.format('X'));
    const breakpoints = [
        ...customRanges
    ];
    breakpoints.shift();
    breakpoints.forEach((hourBreakpoint)=>{
        ticksPoints.push(+startDate.hour(hourBreakpoint[0]).minutes(hourBreakpoint[1]).format('X'));
    });
    ticksPoints.push(+endDate.format('X') + 1);
    return ticksPoints;
};
